import {
  VisitorLogger,
  ControllerFlowAPI,
  useVisitorBi,
} from '@wix/yoshi-flow-editor';
import { ApplicationState } from '../../types';
import { Api } from '../../api';
import { WIX_TIPS_APP_DEF_ID } from '../../consts';
import _ from 'lodash';

export interface BiLogger extends VisitorLogger {
  update: (
    state: Omit<ApplicationState, 'environmentModes' | 'status'>,
  ) => void;
}

const updateDefaultBiParams = (
  viewerBiLogger: VisitorLogger,
  state: ApplicationState,
) => {
  const mapStateToDefaultBiParams = () => {
    const catalogAppId = _.uniq(
      state?.checkoutInfo?.checkout?.lineItems?.map(
        (lineItem) => lineItem.catalogReference?.appId,
      ),
    ).join(',');

    return {
      appId: WIX_TIPS_APP_DEF_ID,
      catalogAppId,
      ecomId: state.checkoutInfo?.checkout?.purchaseFlowId,
      checkoutId: state.checkoutInfo?.checkout?.id,
    };
  };

  viewerBiLogger?.updateDefaults?.(mapStateToDefaultBiParams());
};

export function createBiLogger({
  flowAPI,
  api,
}: {
  flowAPI: ControllerFlowAPI;
  api: Api;
}): BiLogger | undefined {
  const { bi: viewerBiLogger } = flowAPI;
  const shouldInitializeBiLogger = viewerBiLogger && !api.isSSR();

  if (!shouldInitializeBiLogger) {
    return undefined;
  }

  return Object.assign(viewerBiLogger, {
    update: (state: ApplicationState) =>
      updateDefaultBiParams(viewerBiLogger, state),
  }) as BiLogger;
}

export function useBiLogger(state: ApplicationState): BiLogger {
  const viewerBiLogger = useVisitorBi();

  updateDefaultBiParams(viewerBiLogger, state);

  if (state?.environmentModes?.isSSR) {
    // do not report if it is SSR
    return Object.assign(viewerBiLogger, {
      report: async (p: any) => {},
    }) as BiLogger;
  }

  return viewerBiLogger as BiLogger;
}
